import { render, staticRenderFns } from "./ProdutosList.vue?vue&type=template&id=066e357e"
import script from "./ProdutosList.vue?vue&type=script&lang=js"
export * from "./ProdutosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports